export enum CompanyPageSectionEnums {
  CompanyOverView = 'company_overview',
  StrategicInsights = 'strategic_insights',
  PitchBuilder = 'pitch_builder',
  KeyPeople = 'key_people',
  Website = 'website',
  Financials = 'financials',
  AssetBreakdown = 'asset_breakdown',
  GeographicalRevenue = 'geographical_revenue',
  LatestNews = 'latest_news',
  HiringFor = 'hiring_for',
  EventsAttending = 'events_attending',
  ImportsExports = 'imports_&_exports',
  ShareInformation = 'share_information',
  Shareholders = 'shareholders',
  Grants = 'grants',
  IndustryPeerComparison = 'industry_peer_comparison',
  IndustryInsights = 'industry_insights',
  RecentLegislation = 'recent_legislation',
  LegalEntityIdentifier = 'legal_entity_identifier',
  Trademarks = 'trademarks',
  PatentsFiled = 'patents_filed',
  GovernmentContractsAwarded = 'government_contracts_awarded',
  OnlineMarketplaces = 'online_marketplaces',
  CompanyCharges = 'company_charges',
  EnergyEmissions = 'energy_and_emissions',
  FunctionalDepartments = 'functional_departments',
  CorporateStructure = 'corporate_structure',
  CrossSellOpportunities = 'cross_sell_opportunities',
  CorporateOfficers = 'corporate_officers',
  ProbableSuppliers = 'probable_suppliers',
  SimilarOrganisations = 'similar_organisations',
  VehicleOperatorLicences = 'vehicle_operator_licences',
  MagicInsights = 'magic_insights',
  LandOwnership = 'land_ownership',
}

export const allFinancialTerms = [
  'called_up_share_capital',
  'capital_and_reserves',
  'cash_at_bank',
  'corporation_tax',
  'cost_of_sales',
  'creditors',
  'creditors_after_one_year',
  'creditors_within_one_year',
  'current_assets',
  'debtors',
  'dividends',
  'fixed_assets',
  'gross_profit',
  'interest_payable',
  'net_assets',
  'other_debtors',
  'profit',
  'profit_before_tax',
  'retained_earnings',
  'revenue',
  'shareholders_funds',
  'tangible_assets',
  'tax',
  'total_assets_minus_current_liabilities',
  'trade_debtors',
  'wages_and_salaries',
  'share_premium',
  'net_assets_liabilities_including_pension_asset_liability',
  'net_current_assets_liabilities',
  'total_assets_less_current_liabilities',
  'cash_bank_in_hand',
  'debtors_due_within_one_year',
  'debtors_due_after_one_year',
  'other_debtors_within_one_year',
  'other_debtors_due_after_one_year',
  'tangible_fixed_assets',
  'tangible_fixed_assets_cost_or_valuation',
  'tangible_fixed_assets_depreciation',
  'called_up_share_capital_not_paid_not_expressed_as_current_asset',
  'stocks_inventor',
  'intangible_fixed_assets',
  'intangible_fixed_assets_cost_or_valuation',
  'intangible_fixed_assets_aggregate_amortisation_impairment',
  'investments_fixed_assets',
  'turnover_gross_operating_revenue',
  'other_operating_income',
  'capital_employed',
  'creditors_due_within_one_year',
  'creditors_due_after_one_year',
  'trade_creditors_after_one_year',
  'trade_creditors_within_one_year',
  'other_creditors_due_within_one_year',
  'other_creditors_after_one_year',
  'profit_loss_account_reserve',
  'provisions_for_liabilities_charge',
  'share_premium_account',
  'gross_profit_loss',
  'operating_profit_loss',
  'profit_loss_for_period',
  'staff_costs',
  'average_number_employees_during_period',
  'raw_materials_consumables',
  'submitted',
];

export const countriesList = [
  {
    name: 'United Kingdom',
    value: 'GB',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Afghanistan',
    value: 'AF',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Aland Islands',
    value: 'AX',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Albania',
    value: 'AL',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Algeria',
    value: 'DZ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'American Samoa',
    value: 'AS',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Andorra',
    value: 'AD',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Angola',
    value: 'AO',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Anguilla',
    value: 'AI',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Antarctica',
    value: 'AQ',
    continent: 'Antarctica',
    shouldShow: true,
  },
  {
    name: 'Antigua and Barbuda',
    value: 'AG',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Argentina',
    value: 'AR',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Armenia',
    value: 'AM',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Aruba',
    value: 'AW',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Australia',
    value: 'AU',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Austria',
    value: 'AT',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Azerbaijan',
    value: 'AZ',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Bahamas',
    value: 'BS',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Bahrain',
    value: 'BH',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Bangladesh',
    value: 'BD',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Barbados',
    value: 'BB',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Belarus',
    value: 'BY',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Belgium',
    value: 'BE',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Belize',
    value: 'BZ',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Benin',
    value: 'BJ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Bermuda',
    value: 'BM',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Bhutan',
    value: 'BT',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Bolivia',
    value: 'BO',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Bosnia and Herzegovina',
    value: 'BA',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Botswana',
    value: 'BW',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Bouvet Island',
    value: 'BV',
    continent: 'Antarctica',
    shouldShow: true,
  },
  {
    name: 'Brazil',
    value: 'BR',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'British Indian Ocean Territory',
    value: 'IO',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Brunei Darussalam',
    value: 'BN',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Bulgaria',
    value: 'BG',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Burkina Faso',
    value: 'BF',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Burundi',
    value: 'BI',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Cambodia',
    value: 'KH',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Cameroon',
    value: 'CM',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Canada',
    value: 'CA',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Cape Verde',
    value: 'CV',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Caribbean Netherlands',
    value: 'BQ',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Cayman Islands',
    value: 'KY',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Central African Republic',
    value: 'CF',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Chad',
    value: 'TD',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Chile',
    value: 'CL',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'China',
    value: 'CN',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Christmas Island',
    value: 'CX',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Cocos (Keeling) Islands',
    value: 'CC',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Colombia',
    value: 'CO',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Comoros',
    value: 'KM',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Congo',
    value: 'CG',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Congo, Democratic Republic of',
    value: 'CD',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Cook Islands',
    value: 'CK',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Costa Rica',
    value: 'CR',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: "Cote d'Ivoire",
    value: 'CI',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Croatia',
    value: 'HR',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Cuba',
    value: 'CU',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Curacao',
    value: 'CW',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Cyprus',
    value: 'CY',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Czech Republic',
    value: 'CZ',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Denmark',
    value: 'DK',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Djibouti',
    value: 'DJ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Dominica',
    value: 'DM',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Dominican Republic',
    value: 'DO',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Ecuador',
    value: 'EC',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Egypt',
    value: 'EG',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'El Salvador',
    value: 'SV',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Equatorial Guinea',
    value: 'GQ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Eritrea',
    value: 'ER',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Estonia',
    value: 'EE',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Ethiopia',
    value: 'ET',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Falkland Islands',
    value: 'FK',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Faroe Islands',
    value: 'FO',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Fiji',
    value: 'FJ',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Finland',
    value: 'FI',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'France',
    value: 'FR',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'French Guiana',
    value: 'GF',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'French Polynesia',
    value: 'PF',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'French Southern Territories',
    value: 'TF',
    continent: 'Antarctica',
    shouldShow: true,
  },
  {
    name: 'Gabon',
    value: 'GA',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Gambia',
    value: 'GM',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Georgia',
    value: 'GE',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Germany',
    value: 'DE',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Ghana',
    value: 'GH',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Gibraltar',
    value: 'GI',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Greece',
    value: 'GR',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Greenland',
    value: 'GL',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Grenada',
    value: 'GD',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Guadeloupe',
    value: 'GP',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Guam',
    value: 'GU',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Guatemala',
    value: 'GT',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Guernsey',
    value: 'GG',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Guinea',
    value: 'GN',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Guinea-Bissau',
    value: 'GW',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Guyana',
    value: 'GY',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Haiti',
    value: 'HT',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Heard and McDonald Islands',
    value: 'HM',
    continent: 'Antarctica',
    shouldShow: true,
  },
  {
    name: 'Honduras',
    value: 'HN',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Hong Kong',
    value: 'HK',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Hungary',
    value: 'HU',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Iceland',
    value: 'IS',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'India',
    value: 'IN',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Indonesia',
    value: 'ID',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Iran',
    value: 'IR',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Iraq',
    value: 'IQ',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Ireland',
    value: 'IE',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Isle of Man',
    value: 'IM',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Israel',
    value: 'IL',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Italy',
    value: 'IT',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Jamaica',
    value: 'JM',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Japan',
    value: 'JP',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Jersey',
    value: 'JE',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Jordan',
    value: 'JO',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Kazakhstan',
    value: 'KZ',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Kenya',
    value: 'KE',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Kiribati',
    value: 'KI',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Kuwait',
    value: 'KW',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Kyrgyzstan',
    value: 'KG',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: "Lao People's Democratic Republic",
    value: 'LA',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Latvia',
    value: 'LV',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Lebanon',
    value: 'LB',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Lesotho',
    value: 'LS',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Liberia',
    value: 'LR',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Libya',
    value: 'LY',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Liechtenstein',
    value: 'LI',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Lithuania',
    value: 'LT',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Luxembourg',
    value: 'LU',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Macau',
    value: 'MO',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Macedonia',
    value: 'MK',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Madagascar',
    value: 'MG',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Malawi',
    value: 'MW',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Malaysia',
    value: 'MY',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Maldives',
    value: 'MV',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Mali',
    value: 'ML',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Malta',
    value: 'MT',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Marshall Islands',
    value: 'MH',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Martinique',
    value: 'MQ',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Mauritania',
    value: 'MR',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Mauritius',
    value: 'MU',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Mayotte',
    value: 'YT',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Mexico',
    value: 'MX',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Micronesia, Federated States of',
    value: 'FM',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Moldova',
    value: 'MD',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Monaco',
    value: 'MC',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Mongolia',
    value: 'MN',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Montenegro',
    value: 'ME',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Montserrat',
    value: 'MS',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Morocco',
    value: 'MA',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Mozambique',
    value: 'MZ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Myanmar',
    value: 'MM',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Namibia',
    value: 'NA',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Nauru',
    value: 'NR',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Nepal',
    value: 'NP',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'New Caledonia',
    value: 'NC',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'New Zealand',
    value: 'NZ',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Nicaragua',
    value: 'NI',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Niger',
    value: 'NE',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Nigeria',
    value: 'NG',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Niue',
    value: 'NU',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Norfolk Island',
    value: 'NF',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Northern Mariana Islands',
    value: 'MP',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'North Korea',
    value: 'KP',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Norway',
    value: 'NO',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Oman',
    value: 'OM',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Pakistan',
    value: 'PK',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Palau',
    value: 'PW',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Palestine, State of',
    value: 'PS',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Panama',
    value: 'PA',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Papua New Guinea',
    value: 'PG',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Paraguay',
    value: 'PY',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Peru',
    value: 'PE',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Philippines',
    value: 'PH',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Pitcairn',
    value: 'PN',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Poland',
    value: 'PL',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Portugal',
    value: 'PT',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Puerto Rico',
    value: 'PR',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Qatar',
    value: 'QA',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Reunion',
    value: 'RE',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Romania',
    value: 'RO',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Russian Federation',
    value: 'RU',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Rwanda',
    value: 'RW',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Saint Barthelemy',
    value: 'BL',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Saint Helena',
    value: 'SH',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Saint Kitts and Nevis',
    value: 'KN',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Saint Lucia',
    value: 'LC',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Saint-Martin (France)',
    value: 'MF',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Saint Vincent and the Grenadines',
    value: 'VC',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Samoa',
    value: 'WS',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'San Marino',
    value: 'SM',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Sao Tome and Principe',
    value: 'ST',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Saudi Arabia',
    value: 'SA',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Senegal',
    value: 'SN',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Serbia',
    value: 'RS',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Seychelles',
    value: 'SC',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Sierra Leone',
    value: 'SL',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Singapore',
    value: 'SG',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Sint Maarten (Dutch part)',
    value: 'SX',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Slovakia',
    value: 'SK',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Slovenia',
    value: 'SI',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Solomon Islands',
    value: 'SB',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Somalia',
    value: 'SO',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'South Africa',
    value: 'ZA',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
    continent: 'Antarctica',
    shouldShow: true,
  },
  {
    name: 'South Korea',
    value: 'KR',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'South Sudan',
    value: 'SS',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Spain',
    value: 'ES',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Sri Lanka',
    value: 'LK',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'St. Pierre and Miquelon',
    value: 'PM',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Sudan',
    value: 'SD',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Suriname',
    value: 'SR',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Svalbard and Jan Mayen Islands',
    value: 'SJ',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Swaziland',
    value: 'SZ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Sweden',
    value: 'SE',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Switzerland',
    value: 'CH',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Syria',
    value: 'SY',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Taiwan',
    value: 'TW',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Tajikistan',
    value: 'TJ',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Tanzania',
    value: 'TZ',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Thailand',
    value: 'TH',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'The Netherlands',
    value: 'NL',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Timor-Leste',
    value: 'TL',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Togo',
    value: 'TG',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Tokelau',
    value: 'TK',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Tonga',
    value: 'TO',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Trinidad and Tobago',
    value: 'TT',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Tunisia',
    value: 'TN',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Turkey',
    value: 'TR',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Turkmenistan',
    value: 'TM',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Turks and Caicos Islands',
    value: 'TC',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Tuvalu',
    value: 'TV',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Uganda',
    value: 'UG',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Ukraine',
    value: 'UA',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'United Arab Emirates',
    value: 'AE',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'United States',
    value: 'US',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'United States Minor Outlying Islands',
    value: 'UM',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Uruguay',
    value: 'UY',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Uzbekistan',
    value: 'UZ',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Vanuatu',
    value: 'VU',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Vatican',
    value: 'VA',
    continent: 'Europe',
    shouldShow: true,
  },
  {
    name: 'Venezuela',
    value: 'VE',
    continent: 'South America',
    shouldShow: true,
  },
  {
    name: 'Vietnam',
    value: 'VN',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Virgin Islands (British)',
    value: 'VG',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Virgin Islands (U.S.)',
    value: 'VI',
    continent: 'North America',
    shouldShow: true,
  },
  {
    name: 'Wallis and Futuna Islands',
    value: 'WF',
    continent: 'Oceania',
    shouldShow: true,
  },
  {
    name: 'Western Sahara',
    value: 'EH',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Yemen',
    value: 'YE',
    continent: 'Asia',
    shouldShow: true,
  },
  {
    name: 'Zambia',
    value: 'ZM',
    continent: 'Africa',
    shouldShow: true,
  },
  {
    name: 'Zimbabwe',
    value: 'ZW',
    continent: 'Africa',
    shouldShow: true,
  },
];

export const extendedCountriesList = [
  ...countriesList,
  { name: 'Rest of World', value: 'ROW', shouldShow: true },
  { name: 'European Union', value: 'EU', shouldShow: true },
];

export const magicPreviewDummyData = {
  pillsProducts: [
    'Lorem Ipsum',
    'Dolor Sit',
    'Amet Consect',
    'Adipiscing',
    'Elit Sed',
    'DoEiusmod',
    'Tempor Incidid',
    'UtLabore',
  ],
  pillsFactors: [
    'Vivamus sagittis lacus velkumar',
    'Magna faucibus porta acronym noweifn ',
    'Inceptos bibendum vehicula',
    'Nullam id dolor id nibh',
    'Ligula vehicula ut id elit',
    'Maecenas faucibus mollis',
  ],
  stringSimple:
    'Illum eaque enim eligendi optio mollitia, quia quod obcaecati ducimus quam corrupti temporibus quis magni placeat veniam',
  numberSimple: 25,
  names: [
    'Molly Johnson',
    'Sally Brown',
    'Sebastian Clarke',
    'Mohammed Ali',
    'Zara Patel',
    'Lee Chan',
    'John Smith',
    'David Williams',
    'Emily Davis',
    'Oliver Wilson',
    'Sophia Lewis',
    'Liam Walker',
    'Isabella Martinez',
    'Noah Thompson',
    'Emma Robinson',
    'Lucas King',
    'Ava Turner',
    'Mason Scott',
  ],
  managementRoles: [
    'CEO',
    'VP of Sales',
    'VP of Marketing',
    'HR Director',
    'Finance Director',
    'Operations Director',
    'CFO',
    'COO',
    'CTO',
    'CMO',
    'CIO',
    'Technology Director',
    'Product Manager',
    'Sales Manager',
    'Marketing Manager',
    'Customer Service Manager',
    'Business Development Manager',
    'Legal Counsel',
  ],
  dataForDummyDonut: {
    series: [10, 20, 40, 15],
    labels: ['one', 'two', 'three', 'four'],
  },
  dataForDummyBar: [10, 25, 20, 25, 15, 4, 1],
  dataForCardList: [
    {
      name: 'Card one',
      domain: 'zint.io',
      services_provided: ['Delivery', 'Next-day delivery', 'Order tracking'],
    },
    {
      name: 'Card two',
      domain: 'bbc.com',
      services_provided: ['International delivery'],
    },
    {
      name: 'Card three',
      domain: 'itv.com',
      services_provided: ['International delivery'],
    },
    {
      name: 'Card four',
      domain: 'hbo.com',
      services_provided: ['International delivery'],
    },
  ],
};

export const someCompanyIdsForTestExport = [
  '24616',
  '43070',
  '70000',
  '110215',
  '180369',
  '284057',
  '423523',
  '500247',
  '533375',
  '650221',
  '650790',
  '749865',
  '841132',
  '887109',
  '1023408',
  '1195839',
  '1200496',
  '1281630',
  '1335778',
  '1446853',
  '1695950',
  '1855992',
  '1891228',
  '1994673',
  '2009760',
  '2085452',
  '2102529',
  '2191832',
  '2303789',
  '2316609',
  '2316635',
  '2337568',
  '2416811',
  '2463562',
  '2488983',
  '2534827',
  '2704270',
  '2829715',
  '2833477',
  '2844575',
  '2886467',
  '2980657',
  '3197797',
  '3218003',
  '3357280',
  '3373293',
  '3487884',
  '3521740',
  '3611433',
  '3730991',
  '3804991',
  '5525944',
  '848688',
];
